import { render } from "./CustomerSearchProfiles.vue?vue&type=template&id=2a7d9d70&scoped=true"
import script from "./CustomerSearchProfiles.vue?vue&type=script&lang=js"
export * from "./CustomerSearchProfiles.vue?vue&type=script&lang=js"

import "./CustomerSearchProfiles.vue?vue&type=style&index=0&id=2a7d9d70&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7d9d70"]])

export default __exports__